/** This file is auto generated by convertSvgToJsx.ts */

import type { IconSVGProps } from '../../components/icon/Icon'
const goal_medium = (props?: IconSVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m12.016 11.859 4.167-4.167m0 0 .568-3.75L19.999.75l.502 2.624 2.624.502-3.192 3.248-3.75.568ZM12.613 2.3a9.75 9.75 0 1 0 8.713 8.7m-9.704-4.25A5.251 5.251 0 1 0 16.877 12M6.516 20.25l-.75 3m11.25-3 .75 3"
    />
  </svg>
)
export default goal_medium
